import { render, staticRenderFns } from "./weekly-milling-qty.card.vue?vue&type=template&id=ed40557a&"
import script from "./weekly-milling-qty.card.vue?vue&type=script&lang=js&"
export * from "./weekly-milling-qty.card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports